import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class InternalTruckCardService {
    private apiBaseUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    getTruckCardData(vehicleId: string): Observable<any> {
        const endpoint = `${this.apiBaseUrl}InternalData/internal-truck-card-data?id=${vehicleId}`;
        return this.http.get<any>(endpoint);
    }

    checkTruckAvailability(vehicleId: string): Observable<any> {
        const endpoint = `${this.apiBaseUrl}InternalData/check-truck-availability?id=${vehicleId}`;
        return this.http.get<any>(endpoint);
    }
}
